module.exports = __webpack_public_path__ + "img/tournaments_460.eb0e8f75.png";